//Request
import {PostRequest} from "../../../components/request";
//import {store} from "../../storeConfig/store";

export const LoginManual = user => {
    return dispatch => {
        PostRequest('/api/authorize/login',
            {
                'country_code': user.country_code && user.country_code.toLowerCase(),
                'login': user.phone || user.email,
                'status': user.status
            }).then((result) => {
            let response = result.data;
            if (response.ok) {
                let result = response.data;
                dispatch({
                    type: "CheckPhone",
                    payload: result,
                });
            } else {
                let result = response.errors;
                dispatch({
                    type: "CheckPhone",
                    payload: result,
                });
            }
        }).catch(err => {
            logout();
        })
    }
}

export const VerifyManual = user => {
    return dispatch => {
        PostRequest('/api/authorize/verify',
            {
                'code': user.code,
                'token': user.verify_token
            }).then((result) => {
            let response = result.data;
            if (response.ok) {
                let result = response.data;
                result.status === 1 && localStorage.setItem("token", result.token);
                dispatch({
                    type: "LOGIN",
                    payload: result,
                });
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'user_login',
                    user_type: 'registered'
                });
            } else {
                let result = response.errors;
                dispatch({
                    type: "ERROR",
                    payload: result,
                });
            }
        }).catch(err => {
            logout();
        })
    }
}

export const RegisterManual = user => {
    return dispatch => {
        PostRequest('/api/authorize/register',
            {
                'name': user.name,
                'lastname': user.lastname,
                'national_code':user.national_code,
                'province':user.province,
                'city':user.city,
                'activity_area':user.activity_area,
                'gender': user.gender,
                'token': user.register_token
            }).then((result) => {
            let response = result.data;
            if (response.ok) {
                let result = response.data;
                localStorage.setItem("token", result);
                dispatch({
                    type: "REGISTER",
                    payload: result,
                });
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'user_signup',
                    user_type: 'registered'
                });
            } else {
                let result = response.errors;
                dispatch({
                    type: "ERROR",
                    payload: result,
                });
            }
        }).catch(err => {
            logout();
        })
    }
}

export const logout = () => {
    return dispatch => {
        localStorage.removeItem("token");
        dispatch({type: "LOGOUT", payload: {}});
    }
    //window.location.reload();
}
